import React, { useEffect, useState } from 'react';
import { Table, Button } from 'reactstrap';
import './../../css/CoronaList.css';
import axios from "axios";
import {Link} from 'react-router-dom';
import Swal from 'sweetalert2'

const CoronaList = () => {
  const [responseInfectList, setResponseInfectList] = useState([{}]);

  useEffect(() => {
    callInfectListApi();
  }, []);

  const callInfectListApi = () => {
    axios.post('/api/infection?type=list', {
      testKey : "testValue"
    })
    .then( function(response){
        try {
            setResponseInfectList(response.data.result)
        } catch (error) {
            alert('작업중 오류가 발생하였습니다.'+error);
        }
    })
    .catch( error => {alert('작업중 오류가 발생하였습니다.');return false;} );
  }

  const deleteInfect = (e) => {
    var event_target = e.target
    sweetalertDelete('정말 삭제하시겠습니까?', function() {
        axios.post('/api/infection?type=delete', {
            is_Cncode : event_target.getAttribute('id')
        })
        .then( response => {
          const body = response.data
          if(body === "succ"){
              callInfectListApi()
          }else{
              alert('작업중 오류가 발생하였습니다.')
          } 
        }).catch( error => {alert('작업중 오류가 발생하였습니다.'+error);return false;} );
    })
  }

  const sweetalertDelete = (title, callbackFunc) => {
    Swal.fire({
        title: title,
        text: "",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then((result) => {
        if (result.value) {
          Swal.fire(
            'Deleted!',
            '삭제되었습니다.',
            'success'
          )
        }else{
            return false;
        }
        callbackFunc()
      })
  }

  return (
    <section class="sub_wrap" >
    <article class="s_cnt mp_pro_li ct1 mp_pro_li_admin">
        <div class="li_top">
            <h2 class="s_tit1">확진자 격리 정보 리스트</h2>
            <div class="li_top_sch af">
                <Link to={'/CoronaView/register'}>
                  <Button color="success">확진자 정보 등록</Button>{' '}
                </Link>
            </div>
        </div>

        <div class="list_cont list_cont_admin ct1">
        <Table hover>
            <thead>
                <tr>
                <th width="10%">확진자 번호</th>
                <th width="20%">격리 시설 정보</th>
                <th width="10%">완치여부</th>
                <th width="10%">확진일자</th>
                <th width="10%">생년</th>
                <th width="10%">성별</th>
                <th width="10%">국적</th>
                <th width="20%">수정/삭제</th>
                </tr>
            </thead>
            <tbody>
            {
              responseInfectList.map((position, i) => {
                return (
                    <tr>
                        <th scope="row">{position.num}</th>
                        <td>{position.comment}</td>
                        <td>{position.finish}</td>
                        <td>{position.date}</td>
                        <td>{position.birth}</td>
                        <td>{position.gender}</td>
                        <td>{position.nation}</td>
                        <td>
                            <Button color="warning"><Link to={'/CoronaView/'+position.num}>수정</Link></Button>
                            <Button color="danger" id={position.num} onClick={(e) => deleteInfect(e)}>삭제</Button>
                        </td>
                    </tr>
                );
              })
            }
            </tbody>
        </Table>
        </div>
    </article>
    </section>
  );
};

export default CoronaList;